<template>
  <v-icon
    icon="mdi-checkbox-marked-circle-auto-outline"
    @click="dialog = true"
  ></v-icon>
  <v-dialog v-model="dialog" width="500px">
    <v-card>
      <v-card-text>
        Vai vēlaties lietotājam apstiprināt apliecības nosūtīšanai?
      </v-card-text>
      <v-container class="d-flex justify-space-between align-center">
        <v-btn color="primary" @click="acceptLicenseOrder">Apstiprināt</v-btn>
        <v-btn color="primary" variant="text" @click="dialog = false"
          >Aizvērt</v-btn
        >
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import config from "@/api/config";

export default {
  name: "AcceptLicenseOrderAction",
  props: {
    data: {
      type: Object,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
  },
  emits: ["change"],
  data: () => {
    return {
      dialog: false,
    };
  },
  methods: {
    async acceptLicenseOrder() {
      await fetch(`${config.baseURL}/license_card/accept/${this.data.id}`, {
        method: "GET",
        headers: config.headers,
      }).then(() => {
        this.dialog = false;
        this.$emit("change");
      });
    },
  },
};
</script>
